import * as React from "react";
import styled from "styled-components";
import ButtonLink from "../../ButtonLink";
import Close from "../../icons/Close";
import defaultTheme from "../../defaultTheme";
import { left } from "../../utils/rtl";
import useTranslate from "../../hooks/useTranslate";
var StyledDrawerClose = styled.div.withConfig({
  displayName: "DrawerClose__StyledDrawerClose",
  componentId: "akfg41-0"
})(["margin-", ":", ";"], left, function (_ref) {
  var theme = _ref.theme;
  return theme.orbit.spaceMedium;
});
StyledDrawerClose.defaultProps = {
  theme: defaultTheme
};

var DrawerClose = function DrawerClose(_ref2) {
  var onClick = _ref2.onClick;
  var translate = useTranslate();
  return React.createElement(StyledDrawerClose, null, React.createElement(ButtonLink, {
    onClick: onClick,
    iconLeft: React.createElement(Close, null),
    type: "secondary",
    title: translate("drawer_hide"),
    transparent: true
  }));
};

export default DrawerClose;